module.exports = __webpack_public_path__ + "static/media/newUploadActive.f73e88ae.svg";